import styled from "styled-components";

export const SOnboardingTemplates = styled.div`
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
